import gql from 'graphql-tag';
import ProgramaUniversidadService from '@/views/pagos/services/programa-universidad.service';
import { getheadersrest } from '@/components/Utils';
import { query } from '@/views/oferta_academica/autoria/posgraditos/utils.js';

const MODULO_CERO_NOMBRE = 'Tecnologías de la Información y la Comunicación Transformación Digital';
const MODULO_FINAL_NOMBRE = 'Módulo de Titulacion';
const NOTA_APROBACION_DEFAULT = 71;
const MODALIDAD_ESAM_DEFAULT = 'V';
const PORTADA_DEV_DEFAULT = 'sinfotoentest.jpg';
const VALIDAR_MODULO_MAXIMO_PROGRAMAS_SEDE = false;
const MODULO_MAXIMO_DIPLOMADO = 3;
const MODULO_MAXIMO_MAESTRIA = 6;

export const id_mod_monografia = 382;
export const id_mod_defen_tesis = 383;
export const id_mod_apostilla = 384;

// export const id_mod_monografia = 275;
// export const id_mod_defen_tesis = 491;
// export const id_mod_apostilla = 490;

const fmtDate = f => {
  if (!f) return null;
  const s = String(f).slice(0, 10);
  if (s.includes('/')) return s;
  const [y, m, d] = s.split('-');
  return y && m && d ? `${d}/${m}/${y}` : null;
};

const is_ballivian = (programaUniv) => {
  const idinstitu = programaUniv.sedeUniversidad?.institucion?.id || programaUniv.sedeUniversidad?.universidadId;
  return idinstitu == 20;
}

const is_crear_modulos_0_and_titulacion = (programaUniv) => {
  if(is_ballivian(programaUniv)) return false;
  return true
}

const nombreCompuestoEsam = (postgrado, programa, programaUniv, row) => {
  const universidadId = programaUniv?.sedeUniversidad?.universidadId || row?.universidad_id || row?.universidadId || 'U';
  const nombre = postgrado.nombre
    .replaceAll('Diplomado DIPLOMADO', 'DIPLOMADO')
    .replaceAll('Especialidad ESPECIALIDAD', 'ESPECIALIDAD')
    .replaceAll('Maestría Maestría', 'MAESTRÍA')
    .replaceAll('Maestria Maestria', 'MAESTRÍA');
  return `${nombre} (V${programa.version} G${programa.grupo} ${programa.gestion} S${programa.sede_id} U${universidadId})`;
};

const modalidadProgramaUniversidad = programaUniv => programaUniv?.modalidad || 'teorico';

const normalizarTexto = value => String(value || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase();

const tipoPostgradoPorNombre = (row, programaUniv) => {
  const nombre = normalizarTexto(row?.programaNombre || programaUniv?.programaNombre || programaUniv?.nombreCompuesto);
  if (nombre.includes('diplomado')) return 'diplomado';
  if (nombre.includes('maestria')) return 'maestria';
  return null;
};

const sedeIdPrograma = programa => Number(
  programa?.sedeId ||
  programa?.sede_id ||
  programa?.sede?.id ||
  0
);

const sedeIdRow = row => Number(row?.sede?.id || row?.sedeId || row?.sede_id || 0);

const numeroUltimoModuloConInscripciones = programa => {
  const numero = Number(programa?.ultimoProgramaModuloConInscripciones?.numero);
  return Number.isFinite(numero) ? numero : 0;
};

const errorModuloMaximoProgramasSede = (row, programaUniv, nombre) => {
  if (!VALIDAR_MODULO_MAXIMO_PROGRAMAS_SEDE) return null;

  const tipo = tipoPostgradoPorNombre(row, programaUniv);
  const maximo = tipo === 'diplomado'
    ? MODULO_MAXIMO_DIPLOMADO
    : tipo === 'maestria'
      ? MODULO_MAXIMO_MAESTRIA
      : null;

  if (!maximo) return null;

  const sedeId = sedeIdRow(row);
  if (!sedeId) return null;

  const programasMismaSede = (programaUniv?.programas || []).filter(programa => sedeIdPrograma(programa) === sedeId);
  const programaFueraDeRegla = programasMismaSede.find(programa => numeroUltimoModuloConInscripciones(programa) > maximo);

  if (!programaFueraDeRegla) return null;

  const modulo = numeroUltimoModuloConInscripciones(programaFueraDeRegla);
  const nombrePrograma = programaFueraDeRegla.nombreCompuesto || programaFueraDeRegla.codigo || `ID ${programaFueraDeRegla.id}`;
  return `No se puede crear ${nombre}: ya existe un programa ${tipo} en la sede ${sedeId} con inscripciones hasta el módulo ${modulo} (${nombrePrograma}). Máximo permitido: módulo ${maximo}`;
};

const mensajeError = error => {
  if (!error) return '';
  if (typeof error === 'string') return error;
  try {
    return JSON.stringify(error);
  } catch (e) {
    return String(error);
  }
};

const findModuloPortalName = async (thiz, nombre) => { 
  const sql = gql`query{ getModulos(cursor:10000000,nombre:"${nombre}"){ id,nombre,sigla,tipo } }`;
  const res = await thiz.$apollo.query({ query: sql }).then(({ data }) => data).catch(() => null);
  const modulos = res?.getModulos || [];
  
  const found = modulos.find(m => String(m.nombre).toLowerCase() === String(nombre).toLowerCase());
  if(!found){
    window.console.log('>>> findModuloPortalName', modulos, nombre, found);
  }
  return found || modulos[0] || null;
};

const createModuloPortal = async (thiz, nombre) => {
  const obj = { nombre, sigla: 'MOD-v2', tipo: 'NEW' };
  const sql = gql`mutation{ createModulo(input:${window.stringifyObject(obj)}){ok,modulo{id,nombre,sigla,tipo},errors{message}} }`;
  const res = await thiz.$apollo.mutate({ mutation: sql }).then(({ data }) => data).catch(() => null);
  // window.console.log('createModuloPortal',nombre,res);
  
  return res?.createModulo?.ok ? res.createModulo.modulo : null;
};

const getOrCreateModuloPortal = async (thiz, nombre) => {
  let modulo = await findModuloPortalName(thiz, nombre); 
  if (modulo?.id) return modulo;
  // window.console.log('getOrCreateModuloPortal',nombre);
  
  await createModuloPortal(thiz, nombre);
  modulo = await findModuloPortalName(thiz, nombre);
  // window.console.log('modulo nombremoddd 2',nombre,modulo);
  return modulo;
};

const getOrCreatePostgrado = async (thiz, row) => { 
  // window.console.log('getOrCreatePostgrado', thiz, row);

  let area_id = 1
  const area_idpu = row.areaUniversidad ? row.areaUniversidad.id : 1
  if(area_idpu == 1) area_id = 1 // salud
  else if(area_idpu == 3) area_id = 4 // ingenieria
  else if(area_idpu == 5) area_id = 6 // legal
  else if(area_idpu == 6) area_id = 10 // socila
  else if(area_idpu == 7) area_id = 12 //empresarial

  // dbs ballivian ?
  else if(area_idpu == 21) area_id = 62 // salud
  else if(area_idpu == 19) area_id = 64 // ingenieria
  else if(area_idpu == 20) area_id = 66 // legal
  else if(area_idpu == 22) area_id = 70 // socila
  else if(area_idpu == 18) area_id = 72 // empresarial

  let cate = 1;
  const name = row.programaNombre.toLowerCase();
  if( name.includes('diplomado') ) cate = 1
  else if( name.includes('especialidad') ) cate = 2
  else if( name.includes('maestria') || name.includes('maestría') ) cate = 3
  
 
  const s = query(1, row.programaNombre);
  // const unidad = row.sede? row.sede.unidad_negocio : thiz.$store.state.CARGO.sede.unidad_negocio
  const unidad = row.sede? row.sede.unidad_negocio : -1
  const sql = gql`${s}`;
  let encontrados = await thiz.$apollo.query({ query: sql })
    .then(({ data: { getPostgrados } }) => getPostgrados)
    .catch(() => []);

  if(!encontrados) encontrados = [];
  encontrados = encontrados.filter(x=>x.unidad_negocio_id == unidad && (x.nombre+'').toLowerCase() == name) 
  
  let postgradoId = encontrados?.length ? encontrados[0].id : 0;
  if (!postgradoId) {
    const data = {
      idarea: area_id,
      idcategoria: cate,
      nombre: row.programaNombre,
      portada: 'portadita.jpg',
      creditaje: 1,
      duracion: 1,
      unidad_duracion: 1,
      carga_horaria: 1,
      unidad_negocio_id: unidad,
    };
    const mut = gql`mutation{ createPostgrado(input:${window.stringifyObject(data)}){ok,postgrado{id,nombre,unidad_duracion},errors{message}} }`;
    const res = await thiz.$apollo.mutate({ mutation: mut }).then(({ data }) => data).catch(() => null);
    if (res?.createPostgrado?.ok) postgradoId = res.createPostgrado.postgrado.id;
  }

  if (!postgradoId) return null;
  const q = gql`query{ getPostgrado(id:${postgradoId}){id,nombre,duracion,creditaje,unidad_negocio_id,status,carga_horaria,unidad_duracion,estado,portada,objetivo,dirigido,categoria{id nombre clase_netsuite_id}, area{id nombre}, clasenetsuite{id, nombre} } }`;
  return await thiz.$apollo.query({ query: q }).then(({ data }) => data.getPostgrado).catch(() => null);
};

const monto_x_modulos = (monto, modulos_size) => {
  return monto * modulos_size
}

const crear_planes_modular_harcode = (programaUniv,planes, nombre, monto) => {
  window.console.log('planes',planes,programaUniv);
  
  const xcuota = {
    nombre: nombre,
    tipo_plan_id: 2, //contado 
    aprobado: false,
    estado: true,
    cobros: [{
      concepto_pago_id: 2,
      nombre_concepto: 'Colegiatura',
      monto: monto,
      cuotas: 1
    }]
  }
  planes.push( xcuota )
}

const buildPlanes = (listasPreciosPorTipo, programaUniv, modulos_size, row) => {
  const planes = [];
  const multiplicar_is_balli = is_ballivian(programaUniv);
  let monto_base_modulo = -1

  listasPreciosPorTipo.forEach(tipo => {
    tipo.modalidades.forEach(modalidad => {
      let nombre = `${tipo.tipoListaPrecio} - PLAN ${modalidad.modalidadPago.toUpperCase()}`;
      if((tipo.tipoEstudiante+'').includes('extranjero')){
        nombre += ' INTERNACIONAL'
      }
      
      const esContado = nombre.toLowerCase().includes('contado');
      if(monto_base_modulo < 0){
        const obtener_precio_base = modalidad.conceptos.find(c=>c.conceptoPago?.id==2)?.montoCuota
        if(obtener_precio_base) monto_base_modulo = obtener_precio_base
      } 
      

      const xmontito = (c, modulos_size) => {
        if(esContado){
          if( c.numeroCuotas > 2 ) {
            if(multiplicar_is_balli) return 3
            else return 2
          }
          else return c.numeroCuotas
        }else if(c.admiteCuotasVariables && multiplicar_is_balli){
          return modulos_size
        }else{
          if(!multiplicar_is_balli) { // para esam, cantidad de modulos - mod0 y mod titulacion
            const max_cuotas = modulos_size - 2
            if(max_cuotas < 2) return 2
            return max_cuotas
          }
          return c.numeroCuotas
        }
      }
      
      const xcuota = {
        tipo_plan_id: esContado ? 2 : 1,
        nombre,
        aprobado: false,
        estado: true,
        cobros: modalidad.conceptos.map(c => ({
          concepto_pago_id: c.conceptoPago.id,
          nombre_concepto: c.conceptoPago.nombre,
          monto: multiplicar_is_balli && c.admiteCuotasVariables ? monto_x_modulos(c.monto || c.montoCuota, modulos_size) : c.monto || c.montoCuota,
          // cuotas: esContado ? (c.numeroCuotas > 2 ? 2 : c.numeroCuotas) : c.admiteCuotasVariables ? modulos_size : c.numeroCuotas,
          cuotas: xmontito(c, modulos_size),
          xporcentajeMaximoDescuento: c.porcentajeMaximoDescuento,
        })),
      }
      xcuota.cobros = xcuota.cobros.filter(co=>co.xporcentajeMaximoDescuento<100);
      planes.push(xcuota);
    });
  });

  const tipo = tipoPostgradoPorNombre(row, programaUniv);
  let monto_por_modulo = -1;
  if(tipo === 'diplomado') monto_por_modulo = 400;
  if(tipo === 'maestria') monto_por_modulo = 500

  // CREO QUE ESTO NO ES BUENA IDEA, CREAR PLANES HARDCODE, DEBERIA LLEGAR EN PROGRAMA UNIVERSIDAD
  const esModular = /\bmodular\b/
  // const esModularUpi = /\bmodular\b.*\bupi\b/
  const existe1 = planes.find(x => esModular.test(normalizarTexto(x.nombre)))
  // const existe2 = planes.find(x => esModularUpi.test(normalizarTexto(x.nombre)))
  /*if( multiplicar_is_balli ){
    if( !existe1 ) crear_planes_modular_harcode(programaUniv,planes,'PLAN MODULAR POSGRADO', monto_base_modulo)
    if( !existe2 ) crear_planes_modular_harcode(programaUniv,planes,'PLAN MODULAR POSGRADO UPI', monto_base_modulo)

  } */

  // monto_por_modulo > 0 solo si es diplomado o maestria  
  if(!multiplicar_is_balli && monto_por_modulo > 0) { 
    if( !existe1 ) crear_planes_modular_harcode(programaUniv,planes,'PLAN MODULAR POSGRADO', monto_por_modulo)
    // if( !existe2 ) crear_planes_modular_harcode(programaUniv,planes,'PLAN MODULAR POSGRADO UPI', 350)
  }

  return planes;
};

const buildModulos = async (thiz, modulosUniversidad, programaUniv) => {
  const modulos = [];

  if(is_crear_modulos_0_and_titulacion(programaUniv)){
    const moduloCero = await getOrCreateModuloPortal(thiz, MODULO_CERO_NOMBRE);
    if (!moduloCero?.id) throw new Error(`No se pudo obtener el módulo cero: ${MODULO_CERO_NOMBRE}`);
    modulos.push({
      modulo_id: moduloCero.id,
      numero: 0,
      tipo_calificacion: 'Moodle y Sistema',
    });
  }

  const ordenados = modulosUniversidad.slice().sort((a, b) => a.numero - b.numero);
  for (const m of ordenados) {
    const modulo = await getOrCreateModuloPortal(thiz, m.nombre);
    if (!modulo?.id) throw new Error(`No se pudo obtener el módulo portal: ${m.nombre}`);
    modulos.push({
      modulo_id: modulo.id,
      numero: Number(m.numero),
      tipo_calificacion: 'Moodle y Sistema',
      modulo_programa_universidad_id: m.id,
    });
  }

  if (MODULO_FINAL_NOMBRE && is_crear_modulos_0_and_titulacion(programaUniv)) {
    const moduloFinal = await getOrCreateModuloPortal(thiz, MODULO_FINAL_NOMBRE);
    if (!moduloFinal?.id) throw new Error(`No se pudo obtener el módulo final: ${MODULO_FINAL_NOMBRE}`);
    const ultimoNumero = modulos.reduce((max, m) => Math.max(max, Number(m.numero) || 0), 0);
    modulos.push({
      modulo_id: moduloFinal.id,
      numero: ultimoNumero + 1,
      tipo_calificacion: 'Moodle y Sistema',
    });
  }
  return modulos;
};

const obtenerResponsableAcademico = async (sedePortalId) => {
  const base = process.env.VUE_APP_SERVER_TALENTO;
  const resultado = {
    responsable: null,
    advertencia: null,
  };

  if (!base || !sedePortalId) {
    resultado.advertencia = 'No se pudo consultar responsable academico: falta VUE_APP_SERVER_TALENTO o sedePortalId';
    return resultado;
  }

  try {
    const url = `${base}/api/empleado-academico/empleados-por-sede?sedePortalId=${sedePortalId}`;
    const empleados = await fetch(url).then(r => {
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      return r.json();
    });

    if (!Array.isArray(empleados) || !empleados.length) return resultado;

    const ordenados = empleados
      .slice()
      .filter(e => e && e.idPersonaPortal)
      .sort((a, b) => Number(a.nivelPrioridad || 999999) - Number(b.nivelPrioridad || 999999));
    const seleccionado = ordenados[0];
    if (!seleccionado?.idPersonaPortal) return resultado;

    resultado.responsable = {
      responsable_id: seleccionado.idPersonaPortal,
      nombre: seleccionado.nombreCompleto || null,
      empleado_academico_id: seleccionado.id || null,
      nivel_prioridad: seleccionado.nivelPrioridad ?? null,
    };
  } catch (e) {
    resultado.advertencia = `No se pudo obtener responsable academico para sedePortalId ${sedePortalId}: ${e?.message || 'error desconocido'}`;
  }

  return resultado;
};

export const validarProgramasUniversidadParaCrearEsam = async (rows) => {
  const programas = [];
  const errores = [];

  for (const row of rows) {
    const res = await ProgramaUniversidadService.findOne(row.id).catch(() => null);
    const programaUniv = res?.data?.datos;
    const nombre = programaUniv?.programaNombre || row.programaNombre || `ID ${row.id}`;
    const modulos = programaUniv?.modulosProgramasUniversidades || [];
    const precios = programaUniv?.listasPreciosPorTipo || [];

    const base = {
      etapa: 'validacion',
      programa_universidad_id: row.id,
      programa_universidad_nombre: nombre,
      sede: row.sede ? { id: row.sede.id, nombre: row.sede.nombre } : null,
    };

    if (!programaUniv) errores.push({ ...base, error: `No se pudo cargar el programa universidad ${nombre}` });
    else if (!modulos.length) errores.push({ ...base, error: `Faltan los módulos en el programa universidad ${nombre}` });
    // else if (is_ballivian(programaUniv) && !precios.length) errores.push({ ...base, error: `Falta la lista de precios en programa universidad ${nombre}` });
    else if (!precios.length) errores.push({ ...base, error: `Falta la lista de precios en programa universidad ${nombre}` });
    else {
      const errorModuloMaximo = errorModuloMaximoProgramasSede(row, programaUniv, nombre);
      if (errorModuloMaximo) errores.push({ ...base, error: errorModuloMaximo });
      else programas.push({ row, programaUniv });
    }
  }

  return { ok: errores.length === 0, errores, programas };
};

export const crearProgramaEsam = async (thiz, row, programaUniv) => {
  const postgrado = await getOrCreatePostgrado(thiz, row);
  if (!postgrado?.id) throw new Error(`No se encontró o creó el postgrado para ${row.programaNombre}`);

  const version = parseInt(programaUniv.version, 10);

  const programa = {
    version: Number.isNaN(version) ? 0 : version,
    grupo: (programaUniv.programas || []).length + 1,
    gestion: new Date().getFullYear(),
    sede_id: row.sede.id,
  };

  const modulos = await buildModulos(thiz, programaUniv.modulosProgramasUniversidades || [], programaUniv);
  const planes = buildPlanes(programaUniv.listasPreciosPorTipo || [], programaUniv, modulos.length, row);
  const responsableAcademico = await obtenerResponsableAcademico(programa.sede_id);

  const obj = {
    nombre_compuesto: nombreCompuestoEsam(postgrado, programa, programaUniv, row),
    posgrado_id: postgrado.id,
    xcategoria_id: postgrado.categoria?.id || 1,
    nota_aprobacion: NOTA_APROBACION_DEFAULT,
    version: programa.version,
    grupo: programa.grupo,
    gestion: programa.gestion,
    sede_id: programa.sede_id,
    modalidad: MODALIDAD_ESAM_DEFAULT,
    portada: PORTADA_DEV_DEFAULT,
    fecha_matricula: fmtDate(row.fecha_inicio_campana),
    fecha_inicio: null,
    fecha_fin: null,
    programa_universidad_id: row.id,
    tipo_programa: modalidadProgramaUniversidad(programaUniv),
    modulos,
    modificar_modulos: [],
    // planes: [], // por el momento no se envian los planes
    planes: planes,
    modificar_planes: [],
    universidad_id: programaUniv?.sedeUniversidad?.universidadId || null,
    es_estrella: programaUniv.esFavorito,
  };

  /* if(is_ballivian(programaUniv)){
    obj.planes = planes;
  }else{
    window.console.log('planes omitidos por el momento', planes);
  } */

  if (responsableAcademico.responsable?.responsable_id) {
    obj.responsable = { responsable_id: responsableAcademico.responsable.responsable_id };
  }

  const res = await fetch(`${process.env.VUE_APP_API_REST}/esam/programa`, {
    method: 'POST',
    headers: getheadersrest(),
    body: JSON.stringify(obj),
  }).then(r => r.json());

  if (!res?.programa_id) {
    throw new Error(mensajeError(res?.error || res?.data || res) || `No se pudo crear el programa ESAM ${row.programaNombre}`);
  }
  return {
    programa_id: res.programa_id,
    nombre_compuesto: obj.nombre_compuesto,
    sede: row.sede ? { id: row.sede.id, nombre: row.sede.nombre } : null,
    modulos_count: obj.modulos.length,
    planes_count: obj.planes.length,
    responsable: responsableAcademico.responsable,
    responsable_advertencia: responsableAcademico.advertencia,
    programa_universidad_id: row.id,
    programa_universidad_nombre: row.programaNombre,
    payload: obj,
    response: res,
  };
};

const parseJsonSeguro = value => {
  if (!value) return null;
  if (typeof value === 'object') return value;
  try {
    return JSON.parse(value);
  } catch (e) {
    return null;
  }
};

const creadosPrevios = reporteAnterior => {
  const anterior = parseJsonSeguro(reporteAnterior);
  const previos = new Map();
  const creados = anterior?.creados || anterior?.exitosos || [];
  const omitidos = anterior?.omitidos || [];
  creados.forEach(item => {
    const id = item.programa_universidad_id || item.programaUniversidadId;
    if (id) previos.set(Number(id), item);
  });
  omitidos.forEach(item => {
    const id = item.programa_universidad_id || item.programaUniversidadId;
    if (id) previos.set(Number(id), item);
  });
  return previos;
};

export const crearProgramasEsamMasivo = async (thiz, rows, opciones = {}) => {
  const omitidos = [];
  const fallidos = [];
  const creados = [];
  const inicio = new Date().toISOString();
  const previos = creadosPrevios(opciones.aprobadosResponseCreate);
  const pendientes = rows.filter(row => {
    const previo = previos.get(Number(row.id));
    if (!previo) return true;
    omitidos.push({
      programa_universidad_id: row.id,
      programa_universidad_nombre: row.programaNombre,
      programa_id: previo.programa_id || null,
      nombre_compuesto: previo.nombre_compuesto || null,
      sede: previo.sede || (row.sede ? { id: row.sede.id, nombre: row.sede.nombre } : null),
      modulos_count: previo.modulos_count || null,
      planes_count: previo.planes_count || null,
      responsable: previo.responsable || null,
      responsable_advertencia: previo.responsable_advertencia || null,
      motivo: 'Ya fue creado en una ejecución anterior',
    });
    return false;
  });

  const validacion = await validarProgramasUniversidadParaCrearEsam(pendientes);
  validacion.errores.forEach(error => fallidos.push(error));

  for (const item of validacion.programas) {
    try {
      const creado = await crearProgramaEsam(thiz, item.row, item.programaUniv);
      creados.push({
        programa_universidad_id: item.row.id,
        programa_universidad_nombre: item.row.programaNombre,
        programa_id: creado.programa_id,
        nombre_compuesto: creado.nombre_compuesto,
        sede: creado.sede,
        modulos_count: creado.modulos_count,
        planes_count: creado.planes_count,
        responsable: creado.responsable,
        responsable_advertencia: creado.responsable_advertencia,
        response: creado.response,
      });
    } catch (e) {
      fallidos.push({
        etapa: 'creacion',
        programa_universidad_id: item.row.id,
        programa_universidad_nombre: item.row.programaNombre,
        sede: item.row.sede ? { id: item.row.sede.id, nombre: item.row.sede.nombre } : null,
        error: e?.message || 'Error al crear programa ESAM',
      });
    }
  }

  const fin = new Date().toISOString();
  const reporte = {
    inicio,
    fin,
    total_solicitados: rows.length,
    total_pendientes: pendientes.length,
    total_creados: creados.length,
    total_fallidos: fallidos.length,
    total_omitidos: omitidos.length,
    creados,
    fallidos,
    omitidos,
  };

  return {
    ok: fallidos.length === 0,
    errores: fallidos.map(f => f.error),
    creados,
    fallidos,
    omitidos,
    reporte,
  };
};
